module.exports = __webpack_public_path__ + "static/media/papua.5af35856.jpg";